/**
 * Guard for markdown html_inline / html_block on web.
 *
 * Assistant replies can include raw HTML/SVG. Injecting unbounded markup
 * (especially SVG with huge width/height) is a known tab-killer: one dumped
 * diagram can add hundreds of MB of compositor memory on Linux software
 * rasterizers. Oversized or clearly-dangerous payloads render as plain text.
 */

export const MAX_RAW_MESSAGE_HTML_CHARS = 8000;
export const MAX_RAW_HTML_DIMENSION_PX = 5000;

// `style` is included because a model-authored stylesheet is not scoped to the
// message and can restyle the whole app.
const DISALLOWED_TAG = /<\s*\/?\s*(?:script|style|iframe|object|embed|link|meta|base|form)\b/i;

// Inline event handlers in attribute position: after whitespace, a slash, or
// a quote. An unanchored /on\w+\s*=/ also fires on prose such as
// "monster = big"; requiring a delimiter keeps that, while still catching
// `<img/onerror=` and `<img src="x"onerror=`.
const INLINE_EVENT_HANDLER = /(?:^|[\s/"'])on[a-z]+\s*=/i;

const DANGEROUS_URL = /(?:javascript|data\s*:\s*text\/html|vbscript)\s*:/i;

// Parsed rather than digit-counted: width="1000" is a legitimate diagram,
// width="40000" is what pins the compositor.
const DIMENSION_ATTR = /\b(?:width|height)\s*=\s*["']?\s*(\d+)/gi;

function hasOversizedDimension(content) {
  DIMENSION_ATTR.lastIndex = 0;
  let match = DIMENSION_ATTR.exec(content);
  while (match !== null) {
    if (Number(match[1]) > MAX_RAW_HTML_DIMENSION_PX) return true;
    match = DIMENSION_ATTR.exec(content);
  }
  return false;
}

export function shouldRenderRawMessageHtml(content) {
  if (typeof content !== 'string' || !content) return false;
  if (content.length > MAX_RAW_MESSAGE_HTML_CHARS) return false;
  if (DISALLOWED_TAG.test(content)) return false;
  if (INLINE_EVENT_HANDLER.test(content)) return false;
  if (DANGEROUS_URL.test(content)) return false;
  if (hasOversizedDimension(content)) return false;
  return true;
}
